<template>
	<div class="jobinfo">
		<el-collapse v-model="activeName" accordion>
			<el-collapse-item name="1" class="test">
				<template slot="title">
					<div class="temtitle">
						<div class="jobname">{{campusjobinfo.positionName}}</div>
						<!-- <div class="info"> -->
						<!-- 							<span>
								<img src="../image/department.png" />
								招聘单位：{{campusjobinfo.department}}
							</span>
							<span class="divider">|</span>
							<span>
								<img src="../image/position.png" />
								工作地点：{{campusjobinfo.base}}
							</span>
							<span class="divider">|</span>
							<span>
								<img src="../image/time.png" />
								发布时间：{{campusjobinfo.updateTime}}
							</span> -->
						<!-- </div> -->
					</div>
				</template>
				<div class="detailedinfo">
					<div class="responsibilities">
						<!-- <span style="font-size: 18px;">工作职责：<br /></span> -->
						<span style="font-size: 18px;">招聘条件：<br /></span>
						<span class="custom"
							style="white-space: pre-wrap;">{{campusjobinfo.responsibilities}}<br /></span>
					</div>
					<!-- <div class="qualification">
						<span style="font-size: 18px;">任职资格：<br /></span>
						<span class="custom">{{campusjobinfo.requirements}}</span>
					</div> -->
					<div class="contacts">
						<span style="font-size: 14px;">联系人：<br /></span>
						<span class="custom">{{campusjobinfo.contact}}</span>
					</div>
					<el-button @click="handresume()" type="primary" class="handbtn">立即投递</el-button>
					<el-button @click="collectionjob()" class="collectionbtn" icon="el-icon-star-off">收藏岗位</el-button>
				</div>
			</el-collapse-item>
		</el-collapse>
		<el-dialog title="投递确认" :visible.sync="requestOrderDialog" width="30%">
			<el-radio-group v-model="order">
				<el-radio label="0">第一志愿</el-radio>
				<el-radio label="1">第二志愿</el-radio>
			</el-radio-group>
			<span slot="footer" class="dialog-footer">
				<el-button @click="requestOrderDialog = false">取 消</el-button>
				<el-button type="primary" @click="requestPosition()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				order: null,
				requestOrderDialog: false,
				activeName: '',
				transferpositionID: {
					positionID: this.campusjobinfo.positionID,
					type: 0,
					order: null,
				}
			};
		},
		props: {
			campusjobinfo: {}
		},
		methods: {
			collectionjob() {
				this.transferpositionID.type = 0;
				this.$emit('transferpositionID', this.transferpositionID)
			},
			requestPosition() {
				this.transferpositionID.order = this.order
				this.transferpositionID.type = 1;
				this.$emit('transferpositionID', this.transferpositionID)
				this.requestOrderDialog = false
			},
			handresume() {
				this.requestOrderDialog = true;
			},
		},
	}
</script>

<style lang="scss" scoped>
	.jobinfo {
		padding: 20px 30px;

		.el-collapse {
			border: none !important;
		}

		::v-deep .el-collapse-item__header {
			height: 80px !important;
			border: none !important;
		}
	}


	.jobname {
		color: #333;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.info {
		display: flex;
		align-items: center;

		img {
			width: 24px;
			height: 24px;
		}
	}

	.divider {
		margin-left: 15px;
		margin-right: 15px;
	}

	.detailedinfo {
		padding-top: 20px;
	}

	.responsibilities {
		margin-top: 35px;
	}

	.contacts {
		margin-top: 35px;
	}

	.qualification {
		margin-top: 35px;
	}

	.custom {
		margin-top: 30px;
		font-size: 14px;
		line-height: 1.5;
	}

	.handbtn {
		width: 140px;
		height: 50px;
		font-size: 16px;
		margin-top: 35px;
		margin-right: 25px;
	}

	.collectionbtn {
		width: 140px;
		height: 50px;
		font-size: 16px;
	}
</style>
